import { render, staticRenderFns } from "./WidgetResellerClients.vue?vue&type=template&id=2f2f5c5b&scoped=true&"
import script from "./WidgetResellerClients.vue?vue&type=script&lang=js&"
export * from "./WidgetResellerClients.vue?vue&type=script&lang=js&"
import style0 from "./WidgetResellerClients.vue?vue&type=style&index=0&id=2f2f5c5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f5c5b",
  null
  
)

export default component.exports